/**
 * A global namespace for 'transitionDuration' string.
 */
const transitionDuration = "transitionDuration";
export default transitionDuration;
